<template>
  <div id="banner">
    <TileConnection 
      :count="rsvpCount"
      subtitle='RSVPs'
    />
    <TileConnection 
      :count="emailCount"
      subtitle='Stories Shared'
    />
    <TileConnection 
      :count="lawmakerFinds"
      subtitle='Lawmaker Finds'
    />
  </div>
</template>

<script>
import TileConnection from './TileConnection';
import axios from 'axios';
export default {
  components: {
    TileConnection,
  },
  data() {
    return {
      emailCount: '-',
      lawmakerFinds: '-',
      rsvpCount: '-'
    };
  },
  created() {
    this.getCounts();
  },
  methods: {
    async getCounts() {
      const countTotals = [
        this.setConnCounts('email', process.env.VUE_APP_EMAILS_CAMPAIGN_ID),
        this.setAdvCounts(process.env.VUE_APP_RSVPS_CAMPAIGN_ID),
        this.setAdvCounts(process.env.VUE_APP_LAWMAKER_CAMPAIGN_ID)
      ]
      const [ emailCount, rsvpCount, lawmakerFinds ] = await Promise.all(countTotals)
      this.emailCount = emailCount;
      this.rsvpCount = rsvpCount;
      this.lawmakerFinds = lawmakerFinds;
    },
    async setConnCounts(connType, campaignId) {
      let total;
      try {
        const response = await axios({
          method: 'get',
          url: process.env.VUE_APP_GET_CAMPAIGN_COUNTS,
          params: {
            campaignId,
            customerId: process.env.VUE_APP_CUSTOMER_ID
          }
        })
        if (response) {
          const { data: { count: { connections: conns }}} = response;
          total = conns[connType];
        }
      } catch (e) {
        console.log('No connection counts were returned due to error: ', e)
        total = 0;
      }

      return total;
    },
    async setAdvCounts(campaignId) {
      let total;
      try {
        const response = await axios({
          method: 'get',
          url: process.env.VUE_APP_GET_CAMPAIGN_COUNTS,
          params: {
            campaignId,
            customerId: process.env.VUE_APP_CUSTOMER_ID
          }
        })
        if (response) {
          const { data: { count: { advocates: { all }} } } = response;
          total = all || 0;
        }
      } catch (e) {
        console.log('No advocate counts were returned due to error: ', e)
        total = 0
      }
      return total;
    }
  }
};
</script>

<style scoped>
  #banner {
    height: 28vh;
    width: 101%;
    display: flex;
    z-index: -1;
  }

  @media (min-width: 1600px) {
    #banner {
      height: 18vh;
    }
  }

  @media (max-width: 1024px) {
    #banner {
      height: 17vh;
    }
  }

  @media (max-width: 768px) {
    #banner {
      height: 15vh;
      margin-top: .5rem;
    }
  }

  @media (max-width: 414px) {
    #banner {
      margin-top: 0px;
      height: 49vh;
      flex-direction: column;
    }
  }

  @media (max-width: 320px) {
    #banner {
      height: 58vh;
      width: 106%
    }
  }


  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #banner {
     height: 40vh;
    }
  }  
</style>